import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./TopBar.scss";

const TopBar = () => {
  let phone = "+02223385625";

  return (
    <>
      <div className="topBar">
        <div className="container">
          <div className="topBarContent">
            <div className="top_logo">
              <Link to="/">
                <img src={logo} className="img-fluid" alt="" />
              </Link>
            </div>

            <div className="helpLine">
              <p className="m-0">
                Hotline:{" "}
                <span>
                  <a href={`tel:${phone}`}>
                    <span>
                      <b>02223385625</b>
                    </span>
                  </a>{" "}
                </span>
              </p>
            </div>

            <div className="loginPart">
              <Link className="btn ripple_btn" to="">
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
